// Vendor imports
const Immutable = require('immutable')
// Common imports
const { FetchStateEnum } = require('client-v2/common/utils/enums')
// Sibling imports
const {
  SEARCH_FORM_RESET,
  SEARCH_FORM_SET_VALUE,
  SEARCH_FORM_SHOW,
  SEARCH_FORM_GOOGLE_SUGGESTIONS_FAILED,
  SEARCH_FORM_GOOGLE_SUGGESTIONS_LOADED,
  SEARCH_FORM_GOOGLE_SUGGESTIONS_LOADING,
  SEARCH_FORM_SUPERSEARCH_SUGGESTIONS_FAILED,
  SEARCH_FORM_SUPERSEARCH_SUGGESTIONS_LOADED,
  SEARCH_FORM_SUPERSEARCH_SUGGESTIONS_LOADING,
  SEARCH_FORM_USER_SUGGESTIONS_FAILED,
  SEARCH_FORM_USER_SUGGESTIONS_LOADED,
  SEARCH_FORM_USER_SUGGESTIONS_LOADING
} = require('./actions')
const SearchFormRecord = require('./record')

// eslint-disable-next-line complexity
function searchFormReducer(state = new SearchFormRecord(), action) {
  switch (action.type) {
    case SEARCH_FORM_SHOW:
      return (state || new SearchFormRecord).merge({
        isVisible: true
      })
    case SEARCH_FORM_SET_VALUE:
      return state.merge({
        value: action.payload
      })
    case SEARCH_FORM_RESET:
      return state.merge({
        isVisible: false,
        googleSuggestionsState: FetchStateEnum.EMPTY,
        googleSuggestions: Immutable.List(),
        userSuggestionsState: FetchStateEnum.EMPTY,
        userSuggestions: Immutable.List(),
        value: ''
      })
    case SEARCH_FORM_GOOGLE_SUGGESTIONS_LOADING:
      return state.merge({
        googleSuggestionsState: FetchStateEnum.LOADING
      })
    case SEARCH_FORM_GOOGLE_SUGGESTIONS_FAILED:
      return state.merge({
        googleSuggestionsState: FetchStateEnum.FAILED,
        googleSuggestions: Immutable.List()
      })
    case SEARCH_FORM_GOOGLE_SUGGESTIONS_LOADED:
      return state.merge({
        googleSuggestionsState: FetchStateEnum.LOADED,
        googleSuggestions: Immutable.fromJS(
          action.payload,
          SearchFormRecord.suggestionsReviver
        )
      })
    case SEARCH_FORM_SUPERSEARCH_SUGGESTIONS_FAILED:
      return state.merge({
        supersearchSuggestionsState: FetchStateEnum.FAILED
      })
    case SEARCH_FORM_SUPERSEARCH_SUGGESTIONS_LOADING:
      return state.merge({
        supersearchSuggestionsState: FetchStateEnum.LOADING
      })
    case SEARCH_FORM_SUPERSEARCH_SUGGESTIONS_LOADED:
      return state.merge({
        supersearchSuggestionsState: FetchStateEnum.LOADED,
        supersearchSuggestions: Immutable.fromJS(
          action.payload,
          SearchFormRecord.suggestionsReviver
        )
      })
    case SEARCH_FORM_USER_SUGGESTIONS_LOADING:
      return state.merge({
        userSuggestionsState: FetchStateEnum.LOADING
      })
    case SEARCH_FORM_USER_SUGGESTIONS_FAILED:
      return state.merge({
        userSuggestionsState: FetchStateEnum.FAILED,
        userSuggestions: Immutable.List()
      })
    case SEARCH_FORM_USER_SUGGESTIONS_LOADED:
      return state.merge({
        userSuggestionsState: FetchStateEnum.LOADED,
        userSuggestions: Immutable.fromJS(
          action.payload,
          SearchFormRecord.suggestionsReviver
        )
      })
    default:
      return state
  }
}

module.exports = searchFormReducer
